import { useEffect } from 'react';
import { useClient } from '../context/ClientContext';

export const useClientTheme = () => {
  const { clientId, theme } = useClient();

  useEffect(() => {
    if (!clientId) return;
    document.body.className = document.body.className
      .split(' ')
      .filter(c => !c.startsWith('tenant-'))
      .join(' ');
    document.body.classList.add(`tenant-${clientId}`);
    return () => {
      document.body.classList.remove(`tenant-${clientId}`);
    };
  }, [clientId]);

  // Apply DB theme colors — overrides static CSS vars when DB has values
  useEffect(() => {
    if (!theme) return;
    const b = document.body;
    if (theme.primaryColor)     b.style.setProperty('--color-primary', theme.primaryColor);
    if (theme.secondaryColor)   b.style.setProperty('--color-secondary', theme.secondaryColor);
    if (theme.accentColor)      b.style.setProperty('--color-accent', theme.accentColor);
    if (theme.backgroundColor)  b.style.setProperty('--background-color', theme.backgroundColor);
    if (theme.textColor)        b.style.setProperty('--text-color', theme.textColor);
    if (theme.primaryTextColor) b.style.setProperty('--color-primary-text', theme.primaryTextColor);
  }, [theme]);
};
